export default function gbpFormat(n: number): string {
  // TODO: Insert commas?
  return `£${(n / 100).toFixed(0)}`;
}
